import styled from "styled-components";

export const PageWrapper = styled.div`
    height: 100%;
    width: 100%;
    background: ${(props) => props.theme.gradients.blueToPurple};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${(props) => props.theme.spacing[32]};
`;

export const OuterCard = styled.div`
    background: ${(props) => props.theme.grayscale.white};
    border-radius: 16px;
    padding: 48px 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
    width: 80%;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${(props) => props.theme.spacing[12]};
    margin-bottom: 80px;
`;

export const WarningText = styled.span`
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.spacing[4]};
    font-size: 0.875rem;
    color: ${(props) => props.theme.grayscale[80]};
`;

export const CardsRow = styled.div`
    display: flex;
    gap: ${(props) => props.theme.spacing[24]};
    margin-bottom: 48px;
    width: 100%;
`;

export const AdvantageCardWrapper = styled.div<{ $selected: boolean }>`
    position: relative;
    border-radius: 12px;
    padding: 2px;
    flex: 1;
    cursor: pointer;
    transition: all 0.2s ease;
    background: ${(props) => (props.$selected ? props.theme.colors.primary[100] : "transparent")};
    box-shadow: ${(props) => props.theme.shadows.card};
    border: 2px solid ${(props) => (props.$selected ? props.theme.colors.primary[100] : props.theme.grayscale[20])};
    width: 450px;
    height: 200px;
`;

export const AdvantageCardInner = styled.div`
    background: ${(props) => props.theme.grayscale.white};
    border-radius: 10px;
    padding: 24px;
    height: 100%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const CardTitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const RadioCircle = styled.div<{ $selected: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid ${(props) => (props.$selected ? props.theme.colors.tertiary[100] : props.theme.grayscale[70])};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &::after {
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${(props) => (props.$selected ? props.theme.colors.tertiary[100] : "transparent")};
    }
`;

export const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const MostPopularBadge = styled.div`
    position: absolute;
    top: -12px;
    right: -5px;
    background: ${(props) => props.theme.colors.primary[100]};
    color: white;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
    letter-spacing: 0.5px;
`;

export const TiersDescription = styled.div`
    margin-top: 12px;
    color: ${(props) => props.theme.colors.tertiary[100]};
    font-size: 12px;
    font-style: italic;
`;
